import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { zeroAddress } from '../../../../utils/config'

const shortAddress = (address = '') => address ? `${address.slice(0, 6)}...${address.slice(-4)}` : '-'

export default function UserListTable(props) {
    const [currentPage, setCurrentPage] = useState(1)
    const { t } = useTranslation()
    const pageCount = Math.max(1, Math.ceil(Number(props.total || 0) / Number(props.perPage || 1)))

    useEffect(() => {
        if (currentPage > pageCount) setCurrentPage(pageCount)
    }, [currentPage, pageCount])

    const pages = useMemo(() => {
        const visible = [...new Set([1, currentPage - 1, currentPage, currentPage + 1, pageCount]
            .filter((page) => page >= 1 && page <= pageCount))]
            .sort((left, right) => left - right)
        return visible.reduce((items, page, index) => {
            if (index > 0 && page - visible[index - 1] > 1) items.push(`ellipsis-${page}`)
            items.push(page)
            return items
        }, [])
    }, [currentPage, pageCount])
    const changePage = (page) => {
        setCurrentPage(page)
        props.changePage?.(page)
    }

    return <div className="console-data-table-shell">
        <div className="console-data-table-scroll">
            <table className="console-data-table">
                <thead>
                    <tr>
                        <th>{t('地址')}</th>
                        <th>{t('邀请人')}</th>
                        <th>{t('铸造数量')}</th>
                        <th>{t('已邀请人数')}</th>
                        {props.showReward !== false && <th>{t('已获得推荐奖励')}</th>}
                    </tr>
                </thead>
                <tbody>
                    {props.list?.length > 0 ? props.list.map((item, index) => <tr key={`invitor-${props.listKey || ''}-${index}-${item.addr}`}>
                        <td><button type="button" className="console-table-copy" onClick={() => props.copy?.(item.addr)} aria-label={t('复制地址')} title={item.addr}><code>{shortAddress(item.addr)}</code><i className="fa fa-copy" /></button></td>
                        <td>{item.inviter && item.inviter !== zeroAddress
                            ? <button type="button" className="console-table-copy" onClick={() => props.copy?.(item.inviter)} aria-label={t('复制邀请人')} title={item.inviter}><code>{shortAddress(item.inviter)}</code><i className="fa fa-copy" /></button>
                            : <span className="console-table-empty">-</span>}</td>
                        <td>{item.mintCount}</td>
                        <td>{item.inviterCount}</td>
                        {props.showReward !== false && <td>{item.reward}</td>}
                    </tr>) : <tr><td className="console-data-table__empty" colSpan={props.showReward === false ? 4 : 5}>{t('暂无用户数据')}</td></tr>}
                </tbody>
            </table>
        </div>

        {pageCount > 1 && <nav className="console-pagination" aria-label={t('分页')}>
            <button type="button" onClick={() => changePage(currentPage - 1)} disabled={currentPage <= 1} aria-label={t('上一页')}><i className="fa fa-chevron-left" /></button>
            {pages.map((page) => typeof page === 'string'
                ? <span key={`${props.listKey || ''}-${page}`}>...</span>
                : <button type="button" key={`${props.listKey || ''}-page-${page}`} className={currentPage === page ? 'is-active' : ''} onClick={() => changePage(page)}>{page}</button>)}
            <button type="button" onClick={() => changePage(currentPage + 1)} disabled={currentPage >= pageCount} aria-label={t('下一页')}><i className="fa fa-chevron-right" /></button>
        </nav>}
    </div>
}
